import { ActionIcon, Button, Card, Group, Image, Loader, Skeleton, Stack, Text } from '@mantine/core';
import { clubsPointList } from '@services/club';
import { IconInfoCircle } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';

const SnappClubPoints = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['clubsPointList'],
    queryFn: () => clubsPointList(),
  });

  const enableButton = (
    <Button
      component="a"
      href="#"
      leftSection={<Image src="/img/snappClubIcon.svg" width="1rem" />}
      rightSection={<Text style={{ opacity: '0.5', fontSize: '8px' }}>امتیاز</Text>}
      radius="lg"
      style={{ color: '#000', backgroundColor: '#FFEA2B', ':hover': { background: '#FFEA2B' } }}
      size="compact-sm"
    >
      {isLoading ? <Loader variant="dots" size="sm" /> : data?.data?.point || 0}
    </Button>
  );

  return isLoading ? (
    <Skeleton w={175} h={90} />
  ) : (
    data?.data?.isActive && (
      <Card bg="gray.1" p="xs">
        <Stack gap="xs">
          <Group justify="space-between" align="center">
            <Text size="sm">اسنپ کلاب</Text>
            <ActionIcon color="dark" radius="lg" p={0}>
              <IconInfoCircle size="1.125rem" />
            </ActionIcon>
          </Group>

          <Group justify="flex-end" gap="xs">
            {enableButton}
          </Group>
        </Stack>
      </Card>
    )
  );
};

export default SnappClubPoints;
